import React from 'react';
import { useLocation } from 'react-router-dom';
import SalesInvoice from './SalesInvoice';
import CreditNote from './CreditNote';

const InvoiceView = () => {
  const location = useLocation();
  const { invoice } = location.state || {};

  if (!invoice) {
    return (
      <div className="container tables bg-white mt-5">
        <div className="alert alert-danger">No invoice data found</div>
      </div>
    );
  }

  // توجيه المستخدم إلى المكون المناسب حسب نوع الفاتورة
  if (invoice.type === 'credit_note') {
    return <CreditNote />;
  } else {
    return <SalesInvoice />;
  }
};

export default InvoiceView;
